module.exports = __webpack_public_path__ + "ai2.no2.ec94814b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ai2.no2.jpg
// module id = qjAm
// module chunks = 0